// extracted by mini-css-extract-plugin
export default {"wrapper":"navbar_wrapper__v+p0a","container":"navbar_container__Orf5C"};